/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateArtistAndLinkRequestEditsInner } from './CreateArtistAndLinkRequestEditsInner';
import {
    CreateArtistAndLinkRequestEditsInnerFromJSON,
    CreateArtistAndLinkRequestEditsInnerFromJSONTyped,
    CreateArtistAndLinkRequestEditsInnerToJSON,
} from './CreateArtistAndLinkRequestEditsInner';

/**
 * 
 * @export
 * @interface CreateArtistAndLinkRequest
 */
export interface CreateArtistAndLinkRequest {
    /**
     * 
     * @type {Array<CreateArtistAndLinkRequestEditsInner>}
     * @memberof CreateArtistAndLinkRequest
     */
    edits: Array<CreateArtistAndLinkRequestEditsInner>;
    /**
     * OpenSearch document _id for the recording being edited
     * @type {string}
     * @memberof CreateArtistAndLinkRequest
     */
    documentId?: string | null;
}

/**
 * Check if a given object implements the CreateArtistAndLinkRequest interface.
 */
export function instanceOfCreateArtistAndLinkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;

    return isInstance;
}

export function CreateArtistAndLinkRequestFromJSON(json: any): CreateArtistAndLinkRequest {
    return CreateArtistAndLinkRequestFromJSONTyped(json, false);
}

export function CreateArtistAndLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateArtistAndLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'edits': ((json['edits'] as Array<any>).map(CreateArtistAndLinkRequestEditsInnerFromJSON)),
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
    };
}

export function CreateArtistAndLinkRequestToJSON(value?: CreateArtistAndLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edits': ((value.edits as Array<any>).map(CreateArtistAndLinkRequestEditsInnerToJSON)),
        'document_id': value.documentId,
    };
}

